import React, { Component } from 'react'
import Link from '../../components/Link';
import { TweenMax } from 'gsap'; 
import CatProduct from '../../components/CatProduct';
import Helmet from '../../components/Helmet';
import AnimationScroll from '../../components/AnimationScroll';
import './style.scss';
export default class Category extends Component {
    onMouseOverHandle(product) {
        //console.log(this.img)
    }

    onMouseLeaveHandle() {
        //TweenMax.to(this.img, 0.4, { scale:1 })
    }
    componentDidMount() {
       // TweenMax.set(this.img, { scale:1 })
    }
  render() {
      console.log(this.props);
    return (
      <div style={{ height:'100%' }}>
        <Helmet
        title={ this.props.pathContext.name + ' //// Studio Gritt' }
        description={this.props.pathContext.description}
        image = "https://studiogritt.files.wordpress.com/2018/04/141.jpg"
      />
        <section className="pageSection">
            <div className="pageHeading">
                <div className="container">
                    { this.props.pathContext.slug === 'blogs' ? null  : <h5>Case Studies</h5> }
                    <h3 >{this.props.pathContext.name}</h3>
                    <p style={{ fontSize:'2rem' }}>{this.props.pathContext.description}</p>
                </div>
            </div>


            <section className="case-study-section product-list">
                <div className="container">
                    <div className="row">
                    {this.props.data.allWordpressPost ? this.props.data.allWordpressPost.edges.map((product) => {
                       

                        return(
                           
                                <CatProduct cat={this.props.pathContext} product={product} />
                     
                        
                    )}) : <div>No Products Found</div> }
                       

                      
                    </div>
                </div>
            </section>



        </section>
      </div>
    )
  }
}


export const query = graphql`

    query allposts($slug: String!){
        allWordpressPost(filter: { categories :{ slug: { eq : $slug } } }) {
          edges {
            node {
              id
              slug
              title
              featured_media {
                id
                source_url
              }
            }
          }
        }
      }
`


// WEBPACK FOOTER //
// ./src/layouts/Category/index.js